import { ParticipantExamResult } from '@core/swagger-client/src/Api';
import { ExamResultType } from '@core/types';
import { Table, useCreateColumnHelper } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const ExamResultsDetails = ({ results }: { results: ParticipantExamResult[] }) => {
    const { t } = useTranslation();
    const columnHelper = useCreateColumnHelper<ParticipantExamResult>();

    const columns = [
        columnHelper.accessor((row) => row.emailAddress, {
            id: 'emailAddress',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.Email')
        }),
        columnHelper.accessor((row) => row.nickname, {
            id: 'nickname',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.Nickname')
        }),
        columnHelper.accessor((row) => row.firstName, {
            id: 'firstName',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.FirstName')
        }),
        columnHelper.accessor((row) => row.lastName, {
            id: 'lastName',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.LastName')
        }),
        columnHelper.accessor((row) => row.companyName, {
            id: 'companyName',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.CompanyName')
        }),
        columnHelper.accessor((row) => row.countryCode, {
            id: 'countryCode',
            cell: (info) => info.getValue(),
            header: () => t('Account.Label.Country')
        }),
        columnHelper.accessor((row) => row.score, {
            id: 'score',
            cell: (info) => info.getValue(),
            header: () => t('Insights.Exam.Label.Score')
        }),
        columnHelper.accessor((row) => row.result, {
            id: 'result',
            cell: (info) => t(`Insights.Exam.Result.${ExamResultType[info.getValue()]}`),
            header: () => t('Insights.Exam.Label.Result')
        })
    ];

    return (
        <div className="bg-white rounded-lg shadow-md">
            <Table columns={columns} data={results} isHeader={true} />
        </div>
    );
};
